import * as React from 'react'

import { type BorderRadiusCorners, Box, Text } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

interface Props {
  date: moment.Moment
  disabled?: boolean
  border?: boolean
}

const Date = ({ date, disabled, border = true }: Props) => {
  const monthBorderRadiusStyle: BorderRadiusCorners = {
    topLeft: 'abs016',
    topRight: 'abs016',
  }

  const borderStyle = {
    color: 'grey400',
    width: 's1',
    style: 'solid',
  } as const

  return (
    <Box
      textAlign="center"
      borderRadius={{
        all: 'abs012',
      }}
      border={
        border
          ? {
              all: borderStyle,
            }
          : {}
      }
      background="grey100"
      width="s40"
      height="s40"
      flexNoShrink
    >
      <Box
        background={disabled ? 'grey400' : 'radicalRed1000'}
        borderRadius={monthBorderRadiusStyle}
        paddingY="s2"
        justifyContent="center"
      >
        <Text color="grey000White" size="50" weight="bold" caps>
          {date.format('MMM')}
        </Text>
      </Box>
      <Text color="grey1000" size="300" weight="semibold">
        {date.format('D')}
      </Text>
    </Box>
  )
}

export default Date
